module.exports = __webpack_public_path__ + "static/img/page_21.ff479afe.png";